import React, { useState, useContext, useEffect } from "react";
import { Container, Box, Typography } from "@mui/material";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { AuthContext } from "./AuthContext";
import { useNavigate } from "react-router-dom";
import postData from './postData';

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";

import MeetingIcon from "@mui/icons-material/Groups";
import ActivityIcon from "@mui/icons-material/DirectionsRun";
import DevelopmentIcon from "@mui/icons-material/Apartment";
import CelebrationIcon from "@mui/icons-material/Celebration";
import dayjs from 'dayjs';

// menu stuff
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuList from '@mui/material/MenuList';
import Divider from '@mui/material/Divider';

import pkg from '../package.json';

const PageCalendarView = () => {
  const navigate = useNavigate();
  // Event type config with icons
  const eventTypeConfig = {
    1: { icon: <MeetingIcon fontSize="small" />, label: "meeting" },
    2: { icon: <ActivityIcon fontSize="small" />, label: "activity" },
    3: { icon: <CelebrationIcon fontSize="small" />, label: "party" },
    4: { icon: <DevelopmentIcon fontSize="small" />, label: "development related event" },
  };

  // get user id
  const { userID, baseURL, logout, neighborhoodSK, isAdministrator } = useContext(AuthContext);

  const [events, setEvents] = useState(undefined);
  const [retryCount, setRetryCount] = useState(0);
  const [internalError, setInternalError] = useState('');

  //-----------------
  // event detail stuff
  const [openEventDetailDialog, setOpenEventDetailDialog] = useState(false);
  const [eventID, setEventID] = useState("");
  const [eventTitle, setEventTitle] = useState("");
  const [eventbody, setEventBody] = useState("");
  const [eventLocation, setEventLocation] = useState("");
  const [eventLocationURL, setEventLocationURL] = useState("");
  const [eventType, setEventType] = useState("");
  const [eventTypeIcon, setEventTypeIcon] = useState(undefined);
  const [eventDateTime, setEventDateTime] = useState("");
  const [eventNeighborhoodName, setEventNeighborhoodName] = useState("");
  const [showEditButton, setShowEditButton] = useState(false);

  //-------------------------------------------------------------
  // get the topic list from the server

  const getEvents = async () => {
    if (events === undefined) {
      const formData = new FormData();
      formData.append('ccnaEventSK', 0);
      var objEntity = await postData(baseURL + 'ccnaEventSelect.php', formData);
      setInternalError(objEntity.theError);
      if (objEntity.theData !== null) {
        setEvents(objEntity.theData);
      } else {
        if (retryCount < 3) {
          // Retry after 3 seconds
          setTimeout(() => setRetryCount(retryCount + 1), 3000);
        } //retry
      } //else 
    }
  }
  useEffect(() => {
    getEvents();
    // eslint-disable-next-line
  }, [retryCount]);


  //---------------------------- 
  // menu functions

  // set up hamberger menu
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleMenuOpen = () => {
    // FullCalendar button is generated dynamically,
    // so grab it directly from the DOM
    const button = document.querySelector(
      '.fc-menuButton-button'
    )
    setAnchorEl(button)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleMenuLogout = () => {
    setAnchorEl(null);
    logout();
    navigate("/");
  };
  const handleMenuLogin = () => {
    setAnchorEl(null);
    logout();
    navigate("/userLogin");
  };
  const handleMenuChangePassword = () => {
    setAnchorEl(null);
    navigate("/userChangePassword");
  };
  const handleMenuAddEvent = () => {
    setAnchorEl(null);
    navigate('/event/0');
  };

  const handleMenuAbout = () => {
  alert(`CCNA Calendar Version ${pkg.version}`);
};

  //---------------------------------
  // Convert events to FullCalendar format

  function mapEvents(events) {
    return events.map((e) => ({
      id: e.sk,
      title: e.title,
      start: e.dateStart,
      end: e.dateEnd,
      extendedProps: {
        type: e.eventType
        , neighborhood: e.neighborhoodName
      },
    }));
  }

  function getTime(theDate) {
    return new Date(theDate).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  //---------------------------------
  // event detail dialog
  function handleDialogOK() {
    setOpenEventDetailDialog(false);
  }

  function handleDialogEdit() {
    navigate(`/event/${eventID}`);
  }
  //---------------------------------
  return (
    <Container sx={{ mt: 2 }}>
      {(events !== undefined) &&
        <FullCalendar
          plugins={[dayGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          events={mapEvents(events)}
          height="auto"
          customButtons={{
            menuButton: {
              text: '☰',
              click: handleMenuOpen
            }
          }
          }
          headerToolbar={{
            left: 'title',
            right: 'prev next today menuButton',
          }}
          eventContent={(arg) => {
            const type = arg.event.extendedProps.type;
            return (
              <Box sx={{
                display: "flex", flexDirection: "column", alignItems: "left", gap: 0.5,
                backgroundColor: "#e6f7fc", width: "100%"
              }}>
                <div >
                  {eventTypeConfig[type]?.icon}
                  <span style={{ fontSize: 12 }}>&nbsp;{getTime(arg.event.start)}</span>
                  <span style={{ fontSize: 12 }}>&nbsp;{arg.event.title}</span>
                </div>
                <div>
                  <span style={{ fontSize: 9 }}>{arg.event.extendedProps.neighborhood}</span>
                </div>
              </Box>
            );
          }}
          eventClick={(info) => {
            info.jsEvent.preventDefault(); // optional safety
            setEventID(info.event.id);
            setEventTitle(info.event.title);
            // get the event record to obtain all the info
            let theEvent = events.find(item => item.sk === info.event.id);
            if (theEvent.neighborhoodSK === "0") {
              setEventNeighborhoodName('for everyone ' + theEvent.neighborhoodName);
            } else {
              setEventNeighborhoodName('hosted by ' + theEvent.neighborhoodName);

            }
            setEventTypeIcon(eventTypeConfig[theEvent.eventType]?.icon);
            setEventType(eventTypeConfig[theEvent.eventType]?.label);
            setEventDateTime(dayjs(theEvent.dateStart).format('ddd - MMM D,YYYY')
              + ' starting at ' + dayjs(theEvent.dateStart).format('h:mm a')
              + ' through ' + dayjs(theEvent.dateEnd).format('h:mm a'));
            setEventLocation(theEvent.eventLocation);
            setEventLocationURL(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(theEvent.eventLocation)}`);
            setEventBody(theEvent.body);
            // determine if the edit button should be shown
            if ((isAdministrator) || (neighborhoodSK === theEvent.neighborhoodSK)) {
              setShowEditButton(true);
            } else {
              setShowEditButton(false);
            }
            // finally show the event details
            setOpenEventDetailDialog(true);
          }}
        />}
      {/**** end of fullCalendar ****/}

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {(userID === null) &&
          <MenuItem onClick={handleMenuLogin}>Log in</MenuItem>}

        {(userID !== null) &&
          <MenuList>
            <Divider />
            <MenuItem onClick={handleMenuAddEvent} >Add Event</MenuItem>
            <MenuItem onClick={handleMenuLogout} >Log out</MenuItem>
            <Divider />
            <MenuItem onClick={handleMenuChangePassword} >Change Password</MenuItem>
          </MenuList>
        }
          <Divider />
          <MenuItem onClick={handleMenuAbout} >About</MenuItem>

      </Menu>
      {(internalError !== "" && retryCount > 2) && <div>Error:{internalError}</div>}
      {/************  detail event dialog ******************************/}
      <Dialog
        open={openEventDetailDialog}

        maxWidth={false}
        slotProps={{
          paper: {
            sx: {
              width: '80vw',
              height: '70vh'
            }
          }
        }}
      >
        <DialogTitle>
          <strong>{eventTitle}</strong>
        </DialogTitle>

        <DialogContent
          sx={{
            flex: 1,
            overflow: 'auto'
          }}
        >
          <Typography>
            <div style={{marginBottom:'20px'}}>{eventTypeIcon}&nbsp;&nbsp;A {eventType} {eventNeighborhoodName}</div>
            <div> {eventDateTime}</div>
            <div style={{ marginBottom: '10px' }}> at <a target="_blank" rel="noreferrer" href={eventLocationURL}>{eventLocation}</a></div>
            <div dangerouslySetInnerHTML={{ __html: eventbody }}></div>
          </Typography>
        </DialogContent>
        <DialogActions>
          {showEditButton && <Button variant="contained" onClick={handleDialogEdit}>Edit</Button>}
          <Button variant="contained" onClick={handleDialogOK}>Close</Button>
        </DialogActions>
      </Dialog>

    </Container>
  );
}

export default PageCalendarView;